import { partTypeListQuerySchema } from '@chukua/common';
import { useDirectoryList } from '../../../hooks/use-directory-list';
import { useDirectoryMutations } from '../../../hooks/use-directory-mutations';
import { createPartType, deactivatePartType, listPartTypes, reactivatePartType, updatePartType } from '../part-types.api';

/** The part type catalogue's server-paged list and its create, edit, deactivate and reactivate. */
export function usePartTypes() {
  const { state, list, isRefreshing, reload } = useDirectoryList(partTypeListQuerySchema, listPartTypes);
  const mutations = useDirectoryMutations(
    { create: createPartType, update: updatePartType, deactivate: deactivatePartType, reactivate: reactivatePartType },
    reload,
  );
  return { state, list, isRefreshing, ...mutations };
}
